<template>
  <el-dialog class="middle-dialog" title="流程提交" :close-on-click-modal="false" :before-close="handleClose" :visible.sync="dialogVisible">
    <div class="rt-flowsubmit-dialog">
      <h2>选择签核流程
        <span>(下拉框中可能存在多个可选项目,请注意选择合适的流程)</span>
      </h2>
      <br />
      <div>
        <el-select v-model="selectedFlowId">
          <el-option v-for="flow in flowList" v-bind:value="flow.new_flowid" :key="flow.new_flowid" :label="flow.new_name">
          </el-option>
        </el-select>
      </div>
      <br />
      <br />
      <div>
        <h2>选择签核用户
          <span>(下拉框中可能存在多个可选人员,请注意选择合适的下一级呈递人)</span>
        </h2>
        <template v-if="stepList != null && stepList.length > 0">
            <div v-for="step in stepList" :key="step.new_flowstepsid">
              <br />
              <h3>{{ step.new_name }}</h3>
              <br />
              <el-select v-model="step.selectedUserId">
                <el-option v-for="user in step.new_stepusers" v-bind:value="user.systemuserid" :key="user.systemuserid" :label="user.fullname">
                </el-option>
              </el-select>
            </div>
        </template>
        <div v-else style="height: 100px;line-height: 100px;text-align: center;color: #888888;">
            无审批步骤
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button v-if="canSubmit" @click="submitFlow" type="primary" :loading="isSubmiting">提交</el-button>
      <el-button @click="closeDialog">关闭</el-button>
    </div>
  </el-dialog>
</template>


<script>
export default {
  name: "RtFlowSubmitDialog",
  data() {
    return {
      isSubmiting: false,
      dialogVisible: false,
      selectedFlowId: "",
      flowList: [],
      selectedUserId: [],
      stepList: [],
      canSubmit: false
    };
  },
  props: {
    entityName: {
      type: String,
      require: true
    },
    entityId: {
      type: String,
      require: true
    },
    onSuccess: {
      type: Function
    },
    flowName:{
      type: String
    },
  },
  mounted: function() {},
  watch: {
    selectedFlowId: function(val) {
      if (rt.isNullOrWhiteSpace(val)) {
        this.stepList = [];
        return;
      }
      rt
        .get(
          "../api/CrmFlow/GetFlowStepList?flowId=" +
            val +
            "&entityName=" +
            this.entityName +
            "&entityId=" +
            this.entityId
        )
        .then(res => {
          for (var i in res) {
            if (
              res[i].new_stepusers != null &&
              res[i].new_stepusers.length > 0
            ) {
              res[i].selectedUserId = res[i].new_stepusers[0].systemuserid;
            }
          }
          this.stepList = res;
          this.canSubmit = true;
        })
        .catch(error => {
          this.canSubmit = false;
          rt.showErrorToast(error);
        });
    }
  },
  methods: {
    getFlowList() {
      rt
        .get(
          "../api/CrmFlow/GetFlowList?entityName=" +
            this.entityName +
            "&entityId=" +
            this.entityId
        )
        .then(res => {
          if (res.length > 0) {
            this.flowList = res;
            if(this.flowName){
               this.flowList = res.filter(m=>m.new_name == this.flowName);
            }
           
            this.selectedFlowId = res[0].new_flowid;
          }
        })
        .catch(error => {
          rt.showErrorToast(error);
        });
    },
    submitFlow() {
      if (this.isSubmiting) {
        return;
      }

      var approveList = [];
      this.stepList.map(step => {
        approveList.push({
          StepId: step.new_flowstepsid,
          ApproveUserId: step.selectedUserId
        });
      });
      var data = {
        EntityId: this.entityId,
        EntityTypeName: this.entityName,
        FlowId: this.selectedFlowId,
        ApproveList: approveList
      };
      this.isSubmiting = true;
      rt
        .post("../api/CrmFlow/submit", data)
        .then(res => {
          rt.showSuccessToast(res);
          if (this.onSuccess) {
            this.onSuccess();
          }
          this.closeDialog();
          this.isSubmiting = false;
        })
        .catch(errorMessage => {
          var exceptionIndex = errorMessage.indexOf(
            "System.Activities.InvalidWorkflowException:"
          );
          if (exceptionIndex > 0) {
            errorMessage = errorMessage.substring(exceptionIndex + 43);
          }

          rt.showErrorToast(errorMessage);
          this.isSubmiting = false;
        });
    },
    handleClose() {
      this.closeDialog();
    },
    closeDialog() {
      this.dialogVisible = false;
      this.flowList = [];
      this.selectedFlowId = "";
    },
    show() {
      this.dialogVisible = true;
      this.getFlowList();
    }
  }
};
</script>

<style>
.rt-flowsubmit-dialog {
  min-height: 400px;
}
.rt-flowsubmit-dialog .el-select {
  width: 100%;
}
.rt-flowsubmit-dialog h2 > span {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// submit-dialog.vue?5bd764ad